import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconMathGreaterThanCircle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconMathGreaterThanCircle"><Circle cx="12" cy="12" r="9.5" stroke="currentColor"/><Path d="M9 8.5L16 12L9 15.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconMathGreaterThanCircle;
